function stringCompare(a, b, reverse = false) {
    const v1 = (String(a)).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const v2 = (String(b)).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    return new Intl.Collator().compare(v1,v2) * (reverse ? -1 : 1);
}

export {stringCompare};
